module.exports = __webpack_public_path__ + "img/kenwood.00a1169.png";